import { lazy } from "react";
import WithSuspense from "../components/loaders/WithSuspense";
import { PUBLIC_PATHS, PRIVATE_PATHS } from "./constants";
import { Navigate } from "react-router-dom";

// CLIENT
const ClientLogin = WithSuspense(
  lazy(() => import("../pages/Client/Auth/Login")),
);
const ClientForgotPassword = WithSuspense(
  lazy(() => import("../pages/Client/Auth/ForgotPassword")),
);
const ClientUpdatePassword = WithSuspense(
  lazy(() => import("../pages/Client/Auth/UpdatePassword")),
);

// ADMIN
const AdminLogin = WithSuspense(
  lazy(() => import("../pages/Admin/Auth/Login")),
);
const AdminForgotPassword = WithSuspense(
  lazy(() => import("../pages/Admin/Auth/ForgotPassword")),
);
const AdminUpdatePassword = WithSuspense(
  lazy(() => import("../pages/Admin/Auth/UpdatePassword")),
);

// CLIENT
const ClientDashboard = WithSuspense(
  lazy(() => import("../pages/Client/Dashboard")),
);

// ADMIN
const Dashboard = WithSuspense(lazy(() => import("../pages/Admin/Dashboard")));
const AdminAccAudit = WithSuspense(
  lazy(() => import("../pages/Admin/Audits/AccountMgtAudits")),
);
const AdminTransAudits = WithSuspense(
  lazy(() => import("../pages/Admin/Audits/TransactionMgtAudits")),
);
const AdminTransAudit = WithSuspense(
  lazy(() => import("../pages/Admin/Audits/TransactionMgtAuditsDetails")),
);

const NewClients = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/NewClients")),
);
const AdminKycStep1 = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/Step1")),
);
const AdminKycStep2 = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/Step2")),
);
const AdminKycStep3 = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/Step3")),
);
const AdminKycStep4 = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/Step4")),
);
const AdminKycStep5 = WithSuspense(
  lazy(() => import("../pages/Admin/Clients/Step5")),
);
const AdminKyc = WithSuspense(lazy(() => import("../pages/Admin/Clients/Kyc")));

const AdminTransactions = WithSuspense(
  lazy(() => import("../pages/Admin/Transaction/All")),
);
const AdminTransactionsPreApprovals = WithSuspense(
  lazy(() => import("../pages/Admin/Transaction/Pre-Approvals")),
);
const AdminStaffs = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Staffs")),
);
const AdminDepts = WithSuspense(
  lazy(() => import("../pages//Admin/Settings/Roles/Depts")),
);
const AdminPermissions = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Roles/Permissions")),
);
const AdminRoles = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Roles")),
);
const AdminRole = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Roles/ViewRole")),
);
const AdminAddRole = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Roles/AddRole")),
);
const AdminCountries = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Extras/Countries")),
);
const AdminStates = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Extras/States")),
);
const AdminCurrencies = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Extras/Currencies")),
);
const AdminDynamics = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Extras/Dynamics")),
);
const AdminLgas = WithSuspense(
  lazy(() => import("../pages/Admin/Settings/Extras/Lgas")),
);

// Clients
const ClientStep1 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/NonAuth/Step1")),
);
const ClientStep2 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/NonAuth/Step2")),
);
const ClientStep3 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/NonAuth/Step3")),
);
const ClientStep4 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/NonAuth/Step4")),
);
const ClientStep5 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/NonAuth/Step5")),
);
const ClientAuthStep1 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/Auth/Step1")),
);
const ClientAuthStep2 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/Auth/Step2")),
);
const ClientAuthStep3 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/Auth/Step3")),
);
const ClientAuthStep4 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/Auth/Step4")),
);
const ClientAuthStep5 = WithSuspense(
  lazy(() => import("../pages/Client/Kyc/Auth/Step5")),
);

export const PUBLIC_ROUTES = [
  // client
  { path: PUBLIC_PATHS.CLIENT_LOGIN, element: <ClientLogin /> },
  {
    path: PUBLIC_PATHS.CLIENT_UPDATE_PASSWORD,
    element: <ClientUpdatePassword />,
  },
  {
    path: PUBLIC_PATHS.CLIENT_FORGOT_PASSWORD,
    element: <ClientForgotPassword />,
  },

  // admin
  { path: PUBLIC_PATHS.ADMIN_LOGIN, element: <AdminLogin /> },
  {
    path: PUBLIC_PATHS.ADMIN_UPDATE_PASSWORD,
    element: <AdminUpdatePassword />,
  },
  {
    path: PUBLIC_PATHS.ADMIN_FORGOT_PASSWORD,
    element: <AdminForgotPassword />,
  },
  {
    path: "*",
    element: (
      <Navigate
        to={
          location.pathname.includes("client")
            ? "/client/auth/login"
            : "/admin/auth/login"
        }
        replace
      />
    ),
  },
];

export const PRIVATE_ROUTES = [
  // CLIENT
  { path: PRIVATE_PATHS.CLIENT_DASHBOARD, element: <ClientDashboard /> },

  // CLIENT KYC FLOW
  { path: PRIVATE_PATHS.CLIENT_STEP_1, element: <ClientStep1 /> },
  { path: PRIVATE_PATHS.CLIENT_STEP_2, element: <ClientStep2 /> },
  { path: PRIVATE_PATHS.CLIENT_STEP_3, element: <ClientStep3 /> },
  { path: PRIVATE_PATHS.CLIENT_STEP_4, element: <ClientStep4 /> },
  { path: PRIVATE_PATHS.CLIENT_STEP_5, element: <ClientStep5 /> },

  { path: PRIVATE_PATHS.CLIENT_AUTH_STEP_1, element: <ClientAuthStep1 /> },
  { path: PRIVATE_PATHS.CLIENT_AUTH_STEP_2, element: <ClientAuthStep2 /> },
  { path: PRIVATE_PATHS.CLIENT_AUTH_STEP_3, element: <ClientAuthStep3 /> },
  { path: PRIVATE_PATHS.CLIENT_AUTH_STEP_4, element: <ClientAuthStep4 /> },
  { path: PRIVATE_PATHS.CLIENT_AUTH_STEP_5, element: <ClientAuthStep5 /> },

  // ADMIN
  { path: PRIVATE_PATHS.ADMIN_DASHBOARD, element: <Dashboard /> },
  { path: PRIVATE_PATHS.ADMIN_ACC_AUDITS, element: <AdminAccAudit /> },
  { path: PRIVATE_PATHS.ADMIN_TRANS_AUDITS, element: <AdminTransAudits /> },
  { path: PRIVATE_PATHS.ADMIN_TRANS_AUDIT, element: <AdminTransAudit /> },
  {
    path: PRIVATE_PATHS.ADMIN_ALL_TRANSACTIONS,
    element: <AdminTransactions />,
  },
  {
    path: PRIVATE_PATHS.ADMIN_PRE_APPROVALS,
    element: <AdminTransactionsPreApprovals />,
  },
  { path: PRIVATE_PATHS.ADMIN_NEW_CLIENTS, element: <NewClients /> },

  // KYC (ADMIN FLOW)
  { path: PRIVATE_PATHS.ADMIN_KYC_STEP_1, element: <AdminKycStep1 /> },
  { path: PRIVATE_PATHS.ADMIN_KYC_STEP_2, element: <AdminKycStep2 /> },
  { path: PRIVATE_PATHS.ADMIN_KYC_STEP_3, element: <AdminKycStep3 /> },
  { path: PRIVATE_PATHS.ADMIN_KYC_STEP_4, element: <AdminKycStep4 /> },
  { path: PRIVATE_PATHS.ADMIN_KYC_STEP_5, element: <AdminKycStep5 /> },

  { path: PRIVATE_PATHS.ADMIN_KYC, element: <AdminKyc /> },

  { path: PRIVATE_PATHS.ADMIN_COUNTRIES, element: <AdminCountries /> },
  { path: PRIVATE_PATHS.ADMIN_STATES, element: <AdminStates /> },
  { path: PRIVATE_PATHS.ADMIN_TRADE_DYNAMICS, element: <AdminDynamics /> },
  { path: PRIVATE_PATHS.ADMIN_CURRENCIES, element: <AdminCurrencies /> },
  { path: PRIVATE_PATHS.ADMIN_LGAS, element: <AdminLgas /> },

  { path: PRIVATE_PATHS.ADMIN_STAFFS, element: <AdminStaffs /> },

  { path: PRIVATE_PATHS.ADMIN_ROLES, element: <AdminRoles /> },
  { path: PRIVATE_PATHS.ADMIN_ROLE, element: <AdminRole /> },
  { path: PRIVATE_PATHS.ADMIN_ADD_ROLE, element: <AdminAddRole /> },

  { path: PRIVATE_PATHS.ADMIN_DEPTS, element: <AdminDepts /> },

  { path: PRIVATE_PATHS.ADMIN_PERMISSIONS, element: <AdminPermissions /> },

  {
    path: "*",
    element: (
      <Navigate
        to={
          location.pathname.includes("client")
            ? "/client/dashboard"
            : "/admin/dashboard"
        }
        replace
      />
    ),
  },
];
